<template>
	<xyz-transition appear xyz="down-100%">
		<nav role="navigation" class="page-nav__wrap patterned-bg bg-75 xyz-out-nested" v-random-bg>
			<slot></slot>
		</nav>
	</xyz-transition>
</template>

<script>
export default {
	name: 'PageNav',
	methods: {
		updateNavOffset() {
			document.documentElement.style.setProperty('--nav-offset', `${this.$el.clientHeight}px`)
		},
		clearNavOffset() {
			document.documentElement.style.setProperty('--nav-offset', '0px')
		},
	},
	mounted() {
		window.addEventListener('resize', this.updateNavOffset)
		this.updateNavOffset()
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateNavOffset)
		this.clearNavOffset()
	},
}
</script>

<style lang="scss" scoped>
.page-nav__wrap {
	position: sticky;
	bottom: 0;
	display: flex;
	width: 100%;
	padding: $spacing-xxs;
	padding-bottom: calc(env(safe-area-inset-bottom) + #{$spacing-xxs});
	z-index: $z-nav;
	box-shadow: 0 0 0.75rem theme-color(700, 0.15);
	background-color: theme-color(600);
	transition: background-color 0.3s $ease-out-quad, box-shadow 0.3s $ease-out-quad;
}

::v-deep {
	.tab {
		position: relative;
		height: 2rem;
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: $fs-small;
		font-weight: $fw-medium;
		color: transparentize(white, 0.15);
		padding: 0;
		transition: opacity 0.3s $ease-out-quad, color 0.3s $ease-out-quad, background-color 0.3s $ease-out-quad;

		&:hover {
			color: white;
		}

		.icon-svg {
			--iconColor: currentColor;
			margin-right: 0.5rem;
			width: 14px;
			height: auto;
			transition: fill 0.2s $ease-out-quad;
		}

		&.active {
			color: theme-color(600);
			font-weight: $fw-bold;

			&:hover {
				color: theme-color(600);
			}
		}
	}
}
</style>
